module.exports = __webpack_public_path__ + "img/ILCE6700.01509ab0.jpg";